import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ModalHeader, ModalContent, ModalFooter } from '@bibliocommons/modal';
import { ExclamationMarkTriangle } from '@bibliocommons/deprecated-base-icons';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';

import './DeleteConfirmationModal.scss';

export class DeleteConfirmationModal extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handlePrimaryAction() {
    const { shelfActions, items, isBatch } = this.props;
    const shelfName = items.first().get('shelf');
    const shelfItemIds = items.map(item => item.get('id')).toArray();
    const metadataIds = items.map(item => item.get('metadataId')).toArray();

    shelfActions.removeShelfItems({
      shelfName,
      shelfItemIds,
      metadataIds,
      isBatch,
      postSuccess: () => {
        this.props.postSuccess();
        this.handleClose();
      }
    });
  }

  handleClose() {
    this.props.modalActions.closeModal(this.props.modalKey);
  }

  render() {
    const { items } = this.props;

    return (
      <ModalContainer
        className="cp-delete-confirmation-modal"
        modalKey={this.props.modalKey}
        handleClose={this.handleClose}
      >
        <ModalHeader title={<FormattedMessage id="remove_item_from_shelves" values={{ count: items.size }} />} />
        <ModalContent>
          <div className="shelves-modal-content">
            <div className="shelves-modal-content-warning">
              <ExclamationMarkTriangle className="shelves-modal-exclamation-icon" />
              <div className="shelves-modal-content-warning-text">
                <FormattedMessage id="remove_item_from_shelves_warning" />
              </div>
            </div>
            <strong>
              <FormattedMessage id="caution_header" />:{' '}
            </strong>
            <FormattedMessage id="remove_item_from_shelves_caution" />
          </div>
        </ModalContent>
        <ModalFooter
          primaryActionButtonText={<FormattedMessage id="remove_items_button" values={{ count: items.size }} />}
          handlePrimaryAction={this.handlePrimaryAction}
          isLoading={this.props.isLoading}
        />
      </ModalContainer>
    );
  }
}

DeleteConfirmationModal.propTypes = {
  modalKey: PropTypes.string,
  items: ImmutablePropTypes.list.isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  postSuccess: PropTypes.func,
  isLoading: PropTypes.bool,
  isBatch: PropTypes.bool
};

DeleteConfirmationModal.defaultProps = {
  postSuccess: () => {}
};

export default DeleteConfirmationModal;
